module.exports = __webpack_public_path__ + "img/saxophone4.3fe8c7b5.png";